import { NOTIFICATION_EVENT_TYPES } from '../../../features/Inbox/constants';
import { inboxFeatureStore } from '../../../features/Inbox/store';
import {
	getEventsFilter,
	getInboxFiltersFromUrl,
} from '../../../features/Inbox/utils/filters';
import { getParamsFromUrl } from '../../../utils/url';
import queryClient from '../../queryClient';
import { notificationQueryKeyFactory } from './constants';

export const getFilters = () => {
	const params = getParamsFromUrl();

	const { page, searchTerm, events, isInclusive } =
		getInboxFiltersFromUrl(params);

	const filters = {
		search_term: searchTerm,
		events: getEventsFilter(NOTIFICATION_EVENT_TYPES, events, isInclusive),
		read: inboxFeatureStore.showRead,
	};

	return {
		page,
		filters,
	};
};

export const invalidateNotificationListQuery = () => {
	queryClient.invalidateQueries({
		queryKey: notificationQueryKeyFactory.allLists(),
	});
};
